module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.0d49d44c.png";